/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Org_Seat_Minimum_Changed_DescInputs */



/**
* | output |
* | --- |
* | "The type of a base seat was changed, scheduled for the next renewal, put back after billing failed, or its scheduled change was cancelled." |
*
* @param {Audit_Details_Org_Seat_Minimum_Changed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_org_seat_minimum_changed_desc = /** @type {((inputs?: Audit_Details_Org_Seat_Minimum_Changed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Org_Seat_Minimum_Changed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Typ eines Basissitzes wurde geändert, für die nächste Verlängerung geplant, nach einer fehlgeschlagenen Abrechnung zurückgesetzt oder die geplante Änderung wurde abgebrochen.")
	return /** @type {LocalizedString} */ ("The type of a base seat was changed, scheduled for the next renewal, put back after billing failed, or its scheduled change was cancelled.")
});